import D2C_Service from '../Service'

class D2C_ServiceApp extends D2C_Service {
  static objectType = 'serviceRole'
  static groupTitle = 'Application'
  static roleName = 'app'
  static roleTitle = 'Application'
  static methods = {
    ...D2C_Service.methods,
    actions: true,
  }
  static fields = {
    ...D2C_Service.fields,
    deployCommands: {
      default: '',
      label: 'Local dependencies and code\'s preparation',
      path: 'deployCommands',
      required: false,
      syntaxis: 'shell',
      tooltip: 'Commands for installing local dependencies and making your code ready to work.\nExamples: npm install, composer install, bower install, etc.\nor do some for preparation:\nExamples: gulp build, grunt build, etc.',
      validate() {
        return null
      },
      creating: {},
      importing: {},
      updating: {},
    },
    preinstall: {
      default: [],
      enum: ['bower', 'grunt', 'gulp', 'node10', 'node12', 'webpack', 'yarn'],
      label: 'Preinstall apps',
      multiple: true,
      path: 'preinstall',
      required: false,
      validate(value) {
        if (typeof value !== 'object') {
          return 'Invalid value'
        }
        value.forEach(app => {
          if (!this.enum.includes(app)) {
            return 'Invalid app'
          }
        })
      },
      creating: {},
      updating: {},
      importing: {},
    },
    source: {
      default: {
        type: 'download',
        url: '',
      },
      label: 'Source',
      path: 'source',
      placeholder: 'https://',
      required: true,
      validate(value) {
        return value.url.length ? null : 'Must be set'
      },
      creating: {},
      importing: {},
      updating: {},
      updatingSource: {},
    },
  }
}

export default D2C_ServiceApp
